/**
 * Utility functions for SVG handling
 */

/**
 * Fetches SVG content from a URL and returns result with state information
 * @param {string} url - The URL to fetch SVG from
 * @returns {Promise<Object>} Promise that resolves to result object with success/error state
 */
export async function fetchSvgContent(url) {
    if (!url) {
        return {
            success: false,
            svgContent: '',
            error: true,
        };
    }
    
    try {
        const response = await fetch(url);
        
        if (!response.ok) {
            console.warn(`Failed to fetch SVG: ${response.status} ${response.statusText}`);
            return {
                success: false,
                svgContent: '',
                error: true,
            };
        }
        
        const svgText = await response.text();
        return {
            success: true,
            svgContent: svgText,
            error: false,
        };
    } catch (error) {
        console.warn('Failed to fetch SVG:', error);
        return {
            success: false,
            svgContent: '',
            error: true,
        };
    }
}
